import { useEffect, useState } from 'react'
import { WifiOff } from 'lucide-react'

/** Top banner that surfaces when navigator.onLine is false.
 *  Per handoff: 55% opacity behind a top banner; calm voice; reassure data safety. */
export function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' && navigator.onLine === false,
  )
  useEffect(() => {
    if (typeof window === 'undefined') return
    const on  = () => setOffline(false)
    const off = () => setOffline(true)
    window.addEventListener('online', on)
    window.addEventListener('offline', off)
    return () => {
      window.removeEventListener('online', on)
      window.removeEventListener('offline', off)
    }
  }, [])

  if (!offline) return null
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-50 bg-cosmic-card-warm/95 backdrop-blur border-b border-rose/30 px-4 py-2 text-center"
    >
      <span className="inline-flex items-center gap-2 text-sm text-text-secondary">
        <WifiOff size={16} strokeWidth={1.75} className="text-rose" />
        You're offline. Your reading is safe. We'll catch up when you're back.
      </span>
    </div>
  )
}
